import { render, staticRenderFns } from "./dialogSupplierDetail.vue?vue&type=template&id=6f047a64&scoped=true"
import script from "./dialogSupplierDetail.vue?vue&type=script&lang=js"
export * from "./dialogSupplierDetail.vue?vue&type=script&lang=js"
import style0 from "./dialogSupplierDetail.vue?vue&type=style&index=0&id=6f047a64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f047a64",
  null
  
)

export default component.exports